/**
 * Validates a value is equal or greater than a given value.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {number} context.length The minimum value
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name min
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const res = value >= context.minLimit;
  return Promise.resolve(res ? null : 'not-min');
}

module.exports = validate;